// extracted by mini-css-extract-plugin
module.exports = {"newUIMenuWrapper":"DetailsInnerHeader__newUIMenuWrapper--N4E","newUIMenuContainer":"DetailsInnerHeader__newUIMenuContainer--3Kr","active":"DetailsInnerHeader__active--7Zp"};